/*
 * @Descripttion: 
 * @Author: huxianglong
 * @Date: 2023-05-03 11:17:57
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-05-03 16:14:35
 */
import type { DirectiveBinding } from 'vue'
const testArr = [44,55,22] // 测试权限
import { intersection } from 'lodash-es'
const isPromise  = {
    mounted(el:HTMLElement, binding:DirectiveBinding) {
        if(!intersection(testArr, binding?.value).length) {
          el.remove()
        }
      }
}
export default isPromise